var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCheckediconBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.655 0h2.324c2.723 0 4.183.377 5.505 1.083A7.37 7.37 0 0 1 20.55 4.15c.707 1.322 1.084 2.782 1.084 5.505v2.336c0 2.723-.377 4.183-1.084 5.505a7.37 7.37 0 0 1-3.066 3.067c-1.322.707-2.782 1.083-5.505 1.083H9.655c-2.723 0-4.183-.376-5.505-1.083a7.37 7.37 0 0 1-3.067-3.067C.377 16.174 0 14.714 0 11.991V9.655C0 6.932.377 5.472 1.083 4.15A7.37 7.37 0 0 1 4.15 1.083C5.472.377 6.932 0 9.655 0z",
    fill: "#5C88FF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.893,
    strokeLinecap: "round",
    d: "m5.408 11.436 3.651 3.446 7.166-6.765"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckediconBlue);
export default __webpack_public_path__ + "static/media/ic_checkedicon_blue.5bf6b90c5f43b9036b175ef56ea55dd7.svg";
export { ForwardRef as ReactComponent };